<template>
  <div class="p-5 text-left bg-white" @click="$emit('on-click-comment')">
    <!-- 地点情報 -->
    <div class="w-full overflow-hidden">
      <div class="text-W7 text-[15px] leading-[15px] truncate mb-1">
        {{ comment.spot.name }}
      </div>
      <div
        class="text-W4 text-[11px] leading-[11px] truncate text-gray400 truncate"
      >
        {{ `${distanceText()}${comment.spot.address}` }}
      </div>
    </div>
    <!-- サムネイル画像 -->
    <img
      :src="getThumbnail"
      class="w-full mt-4 rounded-[8px]"
      @error="thumbnailImgOnError"
    />
  </div>
</template>
<script>
import {getDistanceText, calcDistance} from '@/utils/utils'

const CommentCardForTagResult = {
  name: 'CommentCardForTagResult',
  props: {
    comment: {type: Object, required: true},
  },
  emits: ['on-click-comment'],
  computed: {
    /**
     * サムネイル画像
     */
    getThumbnail() {
      return this.comment.thumbnailImg
        ? this.comment.thumbnailImg
        : require('@/assets/NoImage.svg')
    },
    /**
     * 現在地情報
     */
    currentPosition: {
      get() {
        return this.$store.state.currentPosition
      },
    },
  },
  methods: {
    /**
     * サムネイル画像読み込み失敗時処理
     * @param {Event} event イベント情報
     */
    thumbnailImgOnError(event) {
      // 読み込み失敗した場合は、NoImageアイコンを表示する
      const noImageIcon = require('@/assets/NoImage.svg')
      event.target.src = noImageIcon
    },
    /**
     * 表示する距離文言
     * @returns 距離の文言
     */
    distanceText() {
      const coord = this.comment.spot.coord
      const targetPoint = {lat: coord.lat, lon: coord.lon}
      // 現在地と地点間の距離を算出(座標データが存在しない、不適切の場合は空文字が返却)
      const distanceM = calcDistance(targetPoint, this.currentPosition)
      if (typeof distanceM == 'undefined') return ''

      // 表示用に加工して返却
      const showDistance = getDistanceText(distanceM)
      return showDistance
    },
  },
}
export default CommentCardForTagResult
</script>
<style scoped></style>
